import { Popper } from '@material-ui/core';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import React, { useRef, useState } from 'react';

export const tooltipWrapper = {
  width: '288px',
  backgroundColor: 'white',
  borderRadius: '16px',
  padding: '16px',
  marginRight: '12px',
  marginTop: '12px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
  fontFamily: 'Archivo'
};

export const contents = {
  fontSize: '11px',
  fontWeight: 500,
  paddingLeft: '5px'
};

export const subTitle = {
  fontSize: '11px',
  fontWeight: 600,
  marginBottom: '3px'
};
const AboutImageTooltip = () => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <>
      <HelpOutlineOutlinedIcon
        ref={anchorRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div style={tooltipWrapper}>
          <div>
            <h3
              style={{ fontSize: '13px', fontWeight: 600, marginBottom: '3px' }}
            >
              HOW TO EMBED IMAGE
            </h3>
            <p style={{ ...contents, color: '#616161' }}>
              You can embed image by using URL.
            </p>
          </div>
          <div style={{ margin: '10px 0' }}>
            <p style={subTitle}>Export image URL in braze(media library)</p>
            <p style={contents}>1. Upload image to media library</p>
            <p style={contents}>2. Right-click your mouse om image</p>
            <p style={contents}>3. Click 'copy image URL'</p>
          </div>
          <div style={{ marginBottom: '16px' }}>
            <p style={subTitle}>Export image URL in web</p>
            <p style={contents}>1. Right-click your mouse on image</p>
            <p style={contents}>2. Click 'copy image URL'</p>
          </div>
          <a
            style={{
              fontSize: '11px',
              color: '#616161'
            }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://metric-studio.notion.site/Extract-and-insert-image-URL-into-IAM-Studio-through-braze-0e3f930defd34cc889f48e12787bd7db?pvs=4"
          >
            Read more
          </a>
        </div>
      </Popper>
    </>
  );
};
export default AboutImageTooltip;
